module.exports = __webpack_public_path__ + "img/serbia-ministry-of-health.18275048.png";